import { CampaignAllocation } from "features/MarketingMaterials/api/campaignApi.ts";

export const getCampaignAllocationKey = (
	item: Pick<CampaignAllocation, "campaignId" | "storeAllocationId" | "repAllocationId" | "id" | "selectionKey">
) => item.selectionKey ?? `${item.campaignId}|${item.storeAllocationId ?? item.repAllocationId ?? item.id ?? ""}`;

export const getCampaignSummary = (items: CampaignAllocation[]) => {
	const counts = new Map<string, number>();
	items.forEach((item) => {
		const prefix = item.storeNameNumber ?? item.jobName;
		const name = prefix ? `${prefix} - ${item.campaignName}` : item.campaignName;
		counts.set(name, (counts.get(name) ?? 0) + 1);
	});
	return [...counts].map(([name, count]) => `${name}${count > 1 ? ` (${count})` : ""}`);
};

export const getDisplayCampaignAllocations = (items: CampaignAllocation[]) => {
	return items.flatMap((item) => {
		if ((item.quantity ?? 0) <= 1) return [item];

		const baseKey = getCampaignAllocationKey(item);
		return Array.from({ length: item.quantity }, (_, index) => ({
			...item,
			quantity: 1,
			selectionKey: `${baseKey}|${index + 1}`
		}));
	});
};

export const getCampaignSelections = (items: CampaignAllocation[]) =>
	items
		.map((item) => ({
			campaignId: item.campaignId,
			allocationId: item.storeAllocationId ?? item.repAllocationId ?? item.id ?? ""
		}))
		.filter((item) => item.allocationId);
